import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-subtitle-2 font-weight-bold" }
const _hoisted_2 = { class: "d-flex justify-space-between text-caption mb-1" }
const _hoisted_3 = {
  key: 0,
  class: "text-caption mt-2 text-truncate"
}

import { ref, computed, onMounted, onUnmounted } from 'vue';
import { eventService } from '../services/event';


export default /*@__PURE__*/_defineComponent({
  __name: 'LiveWatchHud',
  setup(__props) {

const isVisible = ref(false);
const watchers = ref<Record<string, { processed: number; total: number; active: boolean }>>({});
const currentContainer = ref<any>(null);
const currentWatcher = ref<string>('');

let autoCloseTimer: ReturnType<typeof setTimeout> | null = null;
let inactivityTimer: ReturnType<typeof setTimeout> | null = null;

const totalCount = computed(() => Object.values(watchers.value).reduce((sum, w) => sum + w.total, 0));
const totalProcessed = computed(() => Object.values(watchers.value).reduce((sum, w) => sum + w.processed, 0));
const allFinished = computed(() => {
  const list = Object.values(watchers.value);
  if (list.length === 0) return true;
  return list.every(w => !w.active || (w.total > 0 && w.processed >= w.total));
});

const progressPercent = computed(() => {
  if (totalCount.value === 0) return 0;
  return Math.round((totalProcessed.value / totalCount.value) * 100);
});

const clearAutoCloseTimer = () => {
  if (autoCloseTimer) {
    clearTimeout(autoCloseTimer);
    autoCloseTimer = null;
  }
};

const clearInactivityTimer = () => {
  if (inactivityTimer) {
    clearTimeout(inactivityTimer);
    inactivityTimer = null;
  }
};

const scheduleAutoClose = () => {
  clearAutoCloseTimer();
  autoCloseTimer = setTimeout(() => {
    if (allFinished.value) {
      isVisible.value = false;
      clearInactivityTimer();
    }
  }, 3000);
};

const resetInactivityTimer = () => {
  clearInactivityTimer();
  inactivityTimer = setTimeout(() => {
    if (isVisible.value) {
      isVisible.value = false;
      clearAutoCloseTimer();
    }
  }, 15000);
};

const onWatchStart = (data: any) => {
  isVisible.value = true;
  resetInactivityTimer();
  clearAutoCloseTimer();
  if (data.watcher) {
    watchers.value[data.watcher] = {
      processed: 0,
      total: data.total || 0,
      active: true,
    };
  }
};

const onWatchProgress = (data: any) => {
  if (!isVisible.value) {
    isVisible.value = true;
  }
  resetInactivityTimer();
  const isFinished = data.total > 0 && data.processed >= data.total;
  if (data.watcher && watchers.value[data.watcher]) {
    watchers.value[data.watcher].processed = data.processed;
    watchers.value[data.watcher].total = data.total;
    if (isFinished) {
      watchers.value[data.watcher].active = false;
    }
  } else if (data.watcher) {
    watchers.value[data.watcher] = {
      processed: data.processed,
      total: data.total,
      active: !isFinished,
    };
  }
  currentContainer.value = data.container;
  currentWatcher.value = data.watcher;

  if (allFinished.value) {
    scheduleAutoClose();
  }
};

const onWatchStop = (data: any) => {
  if (data.watcher && watchers.value[data.watcher]) {
    watchers.value[data.watcher].processed = data.processed;
    watchers.value[data.watcher].total = data.total;
    watchers.value[data.watcher].active = false;
  }
  
  if (allFinished.value) {
    scheduleAutoClose();
  }
};

onMounted(() => {
  eventService.on('wud:watch-start', onWatchStart);
  eventService.on('wud:watch-progress', onWatchProgress);
  eventService.on('wud:watch-stop', onWatchStop);
});

onUnmounted(() => {
  clearAutoCloseTimer();
  clearInactivityTimer();
  eventService.off('wud:watch-start', onWatchStart);
  eventService.off('wud:watch-progress', onWatchProgress);
  eventService.off('wud:watch-stop', onWatchStop);
});

function closeHud() {
  isVisible.value = false;
  clearAutoCloseTimer();
  clearInactivityTimer();
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (isVisible.value)
    ? (_openBlock(), _createBlock(_component_v_card, {
        key: 0,
        class: "live-watch-hud",
        elevation: "8"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "d-flex justify-space-between align-center pa-2 pb-0" }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_1, [
                _createVNode(_component_v_icon, {
                  size: "small",
                  color: "primary",
                  class: "mr-1"
                }, {
                  default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                    _createTextVNode("mdi-eye", -1)
                  ]))]),
                  _: 1
                }),
                _cache[1] || (_cache[1] = _createTextVNode(" Live Watch ", -1))
              ]),
              _createVNode(_component_v_btn, {
                icon: "mdi-close",
                size: "x-small",
                variant: "text",
                onClick: closeHud
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, { class: "pa-3" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _cache[2] || (_cache[2] = _createElementVNode("span", null, "Progress", -1)),
                _createElementVNode("span", null, _toDisplayString(totalProcessed.value) + " / " + _toDisplayString(totalCount.value), 1)
              ]),
              _createVNode(_component_v_progress_linear, {
                "model-value": progressPercent.value,
                color: "primary",
                height: "8",
                rounded: ""
              }, null, 8, ["model-value"]),
              (currentContainer.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _cache[3] || (_cache[3] = _createTextVNode(" Inspecting: ", -1)),
                    _createElementVNode("strong", null, _toDisplayString(currentContainer.value.name), 1),
                    _createTextVNode(" (" + _toDisplayString(currentWatcher.value) + ") ", 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})